/* eslint-disable @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-unsafe-assignment */
import { Controller } from "stimulus";

export default class AutogrowTextarea extends Controller<HTMLTextAreaElement> {
	connect() {
		this.autogrow();
	}

	autogrow() {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
		(this.element.parentNode as any).dataset.replicatedValue = this.element.value;
	}
}
